/*
 * Collection filters, sort and grid size.
 * Re-renders the main-collection section with the Section Rendering API
 * and swaps every [data-browse-region] in place.
 */
(function () {
  var root = document.querySelector('[data-collection-browse]');
  if (!root) return;

  var sectionId = root.dataset.sectionId;
  var desktop = window.matchMedia('(min-width: 990px)');
  var cache = {};
  var latestRequest = 0;
  var priceTimer;

  var STORAGE_PANEL = 'wr-filters-open';
  var STORAGE_GRID = 'wr-grid-size';
  var STORAGE_PATTERN = 'wr-show-pattern';

  function readStorage(key) {
    try { return window.localStorage.getItem(key); } catch (e) { return null; }
  }

  function writeStorage(key, value) {
    try { window.localStorage.setItem(key, value); } catch (e) {}
  }

  function panel() {
    return document.getElementById('BrowseFilters');
  }

  function overlay() {
    return root.querySelector('.browse-filters__overlay');
  }

  function isOpen() {
    return root.classList.contains('is-filters-open');
  }

  /* Panel: sidebar on desktop, drawer on mobile */

  function syncToggle() {
    var open = isOpen();
    root.querySelectorAll('[data-filters-toggle]').forEach(function (button) {
      button.setAttribute('aria-expanded', String(open));
      var label = button.querySelector('[data-label-open]');
      if (label) label.textContent = open ? label.dataset.labelOpen : label.dataset.labelClosed;
    });
  }

  function setPanel(open, remember) {
    var drawer = !desktop.matches;
    root.classList.toggle('is-filters-open', open);
    document.documentElement.classList.toggle('browse-drawer-open', open && drawer);
    if (overlay()) overlay().hidden = !(open && drawer);
    syncToggle();

    if (remember && !drawer) writeStorage(STORAGE_PANEL, open ? '1' : '0');

    if (open && drawer && panel()) {
      var close = panel().querySelector('.browse-filters__close');
      if (close) window.requestAnimationFrame(function () { close.focus({ preventScroll: true }); });
    }
  }

  /* Grid size */

  function syncGrid() {
    var size = root.dataset.grid;
    root.querySelectorAll('[data-grid-size]').forEach(function (button) {
      button.setAttribute('aria-pressed', String(button.dataset.gridSize === size));
    });
  }

  function setGrid(size) {
    root.dataset.grid = size;
    writeStorage(STORAGE_GRID, size);
    syncGrid();
  }

  /* Show pattern: swaps card images for the flat pattern image (CSS only) */

  function syncPattern() {
    var on = root.hasAttribute('data-show-pattern');
    root.querySelectorAll('[data-pattern-toggle]').forEach(function (button) {
      button.setAttribute('aria-checked', String(on));
    });
  }

  function setPattern(on) {
    root.toggleAttribute('data-show-pattern', on);
    writeStorage(STORAGE_PATTERN, on ? '1' : '0');
    syncPattern();
  }

  /* Rendering */

  function formQuery() {
    var form = document.getElementById('BrowseFiltersForm');
    var params = new URLSearchParams();
    if (!form) return '';
    new FormData(form).forEach(function (value, key) {
      if (value !== '') params.append(key, value);
    });
    return params.toString();
  }

  function swap(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var openState = {};
    root.querySelectorAll('details[id]').forEach(function (details) {
      openState[details.id] = details.open;
    });
    var focusedId = document.activeElement && root.contains(document.activeElement) ? document.activeElement.id : '';

    root.querySelectorAll('[data-browse-region]').forEach(function (region) {
      var fresh = doc.querySelector('[data-browse-region="' + region.dataset.browseRegion + '"]');
      if (fresh) region.innerHTML = fresh.innerHTML;
    });

    var freshRoot = doc.querySelector('[data-collection-browse]');
    if (freshRoot) root.dataset.activeCount = freshRoot.dataset.activeCount;

    root.querySelectorAll('details[id]').forEach(function (details) {
      if (details.id in openState) details.open = openState[details.id];
    });

    if (focusedId) {
      var focusTarget = document.getElementById(focusedId);
      if (focusTarget) focusTarget.focus({ preventScroll: true });
    }

    syncToggle();
    syncGrid();
    syncPattern();
  }

  function render(query, pushHistory) {
    var url = window.location.pathname + '?section_id=' + sectionId + (query ? '&' + query : '');
    var requestId = ++latestRequest;
    root.classList.add('is-loading');

    var request = cache[url]
      ? Promise.resolve(cache[url])
      : fetch(url).then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        }).then(function (html) {
          cache[url] = html;
          return html;
        });

    request.then(function (html) {
      if (requestId !== latestRequest) return;
      swap(html);
      if (pushHistory) {
        window.history.pushState({ browse: query }, '', window.location.pathname + (query ? '?' + query : ''));
      }
      if (desktop.matches) {
        var top = root.getBoundingClientRect().top;
        if (top < 0) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }).catch(function () {
      window.location.href = window.location.pathname + (query ? '?' + query : '');
    }).then(function () {
      if (requestId === latestRequest) root.classList.remove('is-loading');
    });
  }

  /* Events */

  root.addEventListener('change', function (event) {
    var target = event.target;
    if (target.matches('[data-price-input]')) {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(function () { render(formQuery(), true); }, 600);
      return;
    }
    if (target.matches('[data-sort-select]')) {
      closeSort();
      render(formQuery(), true);
      return;
    }
    if (target.closest('[data-filters-form]')) {
      render(formQuery(), true);
    }
  });

  function closeSort() {
    var sort = root.querySelector('[data-sort]');
    if (sort) sort.open = false;
  }

  document.addEventListener('click', function (event) {
    var sort = root.querySelector('[data-sort]');
    if (sort && sort.open && !sort.contains(event.target)) sort.open = false;
  });

  root.addEventListener('submit', function (event) {
    if (!event.target.matches('[data-filters-form]')) return;
    event.preventDefault();
    render(formQuery(), true);
  });

  root.addEventListener('click', function (event) {
    var link = event.target.closest('[data-filters-link]');
    if (link) {
      event.preventDefault();
      render(new URL(link.href, window.location.origin).searchParams.toString(), true);
      return;
    }
    if (event.target.closest('[data-filters-toggle]')) {
      setPanel(!isOpen(), true);
      return;
    }
    if (event.target.closest('[data-filters-close]')) {
      setPanel(false, true);
      return;
    }
    if (event.target.closest('[data-pattern-toggle]')) {
      setPattern(!root.hasAttribute('data-show-pattern'));
      return;
    }
    var gridButton = event.target.closest('[data-grid-size]');
    if (gridButton) setGrid(gridButton.dataset.gridSize);
  });

  document.addEventListener('keydown', function (event) {
    var sort = root.querySelector('[data-sort]');
    if (event.key === 'Escape' && sort && sort.open) {
      sort.open = false;
      sort.querySelector('summary').focus();
      return;
    }
    if (event.key === 'Escape' && isOpen() && !desktop.matches) {
      setPanel(false, false);
      var toggle = root.querySelector('[data-filters-toggle]');
      if (toggle) toggle.focus();
    }
  });

  window.addEventListener('popstate', function () {
    render(window.location.search.replace(/^\?/, ''), false);
  });

  desktop.addEventListener('change', function () {
    setPanel(desktop.matches && readStorage(STORAGE_PANEL) === '1', false);
  });

  /* Initial state */

  var savedGrid = readStorage(STORAGE_GRID);
  if (savedGrid === 'large' || savedGrid === 'small' || savedGrid === 'dense') root.dataset.grid = savedGrid;
  syncGrid();

  if (readStorage(STORAGE_PATTERN) === '1') root.setAttribute('data-show-pattern', '');
  syncPattern();

  var hasActive = Number(root.dataset.activeCount) > 0;
  var savedPanel = readStorage(STORAGE_PANEL);
  setPanel(desktop.matches && (savedPanel === '1' || (savedPanel === null && hasActive)), false);
})();
